import { GraphQL } from "@rpi/openapi-api";
import { UseRpiPaginationResult } from "./usePagination";

export function useCustomerProducts(
  isSuperAdmin: boolean,
  pagination: UseRpiPaginationResult,
  search: GraphQL.CustomerProductSearch
) {
  const superAdminProductsResult = GraphQL.useCustomerProductsSuperAdminQuery(
    {
      limit: pagination.perPage,
      offset: pagination.offset,
      search,
    },
    {
      enabled: isSuperAdmin,
      onSuccess: (data) => pagination.setTotalCount(data.customerProducts.totalCount),
    }
  );

  const customerProductsResult = GraphQL.useCustomerProductsQuery(
    {
      limit: pagination.perPage,
      offset: pagination.offset,
      search,
    },
    {
      enabled: !isSuperAdmin,
      onSuccess: (data) => pagination.setTotalCount(data.customerProducts.totalCount),
    }
  );

  const queryResult = isSuperAdmin ? superAdminProductsResult : customerProductsResult;
  return {
    data: queryResult.data,
    isLoading: queryResult.isLoading,
    error: queryResult.error,
    refetch: queryResult.refetch,
  };
}
